export default __webpack_public_path__ + "static/media/join-team.b00dedc1.png";